import { Linked_companies_jwt } from "@/models/user";

export type JwtType = {
  token: string | null;
};
export enum role {
  ADMIN = "ROLE_OLKYPASS_ADMIN"
}
export type ResetPasswordRequest = {
  password: string;
  confirm_password: string;
  id: string;
  token: string;
  language: string;
  captcha_token?: string;
};

export type CredentialInterface = {
  id: number;
  user_id: number;
  username: string;
  device_name: string;
  domain_name: string;
  credential_id: string;
  credential_key: unknown;
  signatures: unknown;
};
export type LimitCredentialInterface = {
  id: number;
  credential_id: string;
  device_name: string;
  domain_name: string;
  created_at: string;
  active: number;
};

export type TooManyRequestsReponse = {
  code: number;
  message: string;
};

export const isTooManyRequestsReponse = (value: unknown): value is TooManyRequestsReponse => {
  return (value as TooManyRequestsReponse).code !== undefined;
};

export type CheckEmailExistsMutationResponse = {
  status: number;
  label: string;
  data: CheckEmailExistsResponse;
  bo: boolean;
};

export type CheckExistingEmailResponse = CheckEmailExistsMutationResponse | TooManyRequestsReponse;

export type CheckEmailExistsResponse = {
  code: number;
  existStatus: boolean;
  is2faActivated: boolean;
  existAsAlias: boolean;
  mirrorExist?: boolean;
  realExist?: boolean;

  real_uuid?: string;
};
export interface AccountWelcomeOutput {
  emailExists: boolean;
  email: string;
  is2faActivated: boolean;
  existAsAlias: boolean;
  mirrorExist: boolean;
  realExist?: boolean;

  real_uuid: string | null;
}

export type AuthenticateWebAuthnFullResponse = {
  login: boolean;
  token: string;
  signing_action_id: string;
};

export type AuthenticateWebAuthnResponse = string | AuthenticateWebAuthnFullResponse;

export type CheckLoginResponse = {
  login: boolean;
  two_fa_required: boolean;
  token: string;
  role?: role;
};
export type jwtPayload = {
  roles: string[];
  username: string;
  exp: string;
  linked_companies: Linked_companies_jwt;
};

export type CreateAccountResponse = {
  token: string;
};

export type LoginResponse = {
  token: string;
};
export enum Gender {
  Man = "Mr",
  Woman = "Mme"
}

export enum GenderDTO {
  Man = "Mr",
  Woman = "Mme"
}

export type PartnerMutationResponse = {
  name: string;
  email: string;
  id_bb: number;
};

export type MirrorMutationResponse = {
  data?: {
    uuid: string;
  };
};

export type WebauthnOptionsParams = {
  email: string;
  purpose?: string;
};
export interface JwtDecodeOptions {
  header?: boolean;
}

export interface JwtHeader {
  typ?: string;
  alg?: string;
  kid?: string;
}

export interface JwtPayload {
  iss?: string;
  sub?: string;
  aud?: string[] | string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
}
